module.exports = __webpack_public_path__ + "img/t_0008.0ae55664.gif";